import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '../styles/fontello-custom-fonticon.scss'

// Custom icons
const MY_ICONS = {
  arrow: 'icon-arrow',
  delete: 'icon-delete',
  directory: 'icon-directory',
  document: 'icon-document',
  drag: 'icon-drag',
  dropdown: 'icon-dropdown',
  edit: 'icon-edit',
  notification: 'icon-notification',
  search: 'icon-search',
  star: 'icon-star'
}

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    disable: true,
    themes: {
      light: {
        primary: '#139eff',
        secondary: '#93939b',
        accent: '#139eff',
        error: '#f12d57',
        info: '#139eff',
        success: '#44d22d',
        warning: '#ffa700'
      }
    },

    options: {
      customProperties: true,

      minifyTheme: function (css) {
        return process.env.NODE_ENV === 'production'
          ? css.replace(/[\s|\r\n|\r|\n]/g, '')
          : css
      }
    }
  },
  icons: {
    iconfont: 'md',
    values: MY_ICONS
  }
})
